import VoterAxiosInstance from './VoterAxiosInstance'

export const NominatorService = {
  createUpdateSelfNomination: async (eventId, qid, data) => {
    try {
      await VoterAxiosInstance.put(`/nominations/events/${eventId}/questions/${qid}/nominees/self`, data)
      return { success: true }
    } catch (error) {
      /* empty */
    }
  },
  fetchCandidates: async (eventId, qid, search = '') => {
    try {
      const candidates: any = await VoterAxiosInstance.get(`/nominations/events/${eventId}/questions/${qid}/nominees?search=${search}`)
      return candidates || []
    } catch (error) {
      return []
      /* empty */
    }
  },
  fetchCandidate: async (candidacyId) => {
    try {
      const candidates: any = await VoterAxiosInstance.get(`/nominations/${candidacyId}`)
      return candidates || {}
    } catch (error) {
      /* empty */
    }
  },
  endorseCandidate: async (candidacyId) => {
    try {
      await VoterAxiosInstance.put(`/nominations/${candidacyId}/endorse`)
      return { success: true }
    } catch (error) {
      /* empty */
    }
  },
  unEndorseCandidate: async (candidacyId) => {
    try {
      await VoterAxiosInstance.delete(`/nominations/${candidacyId}/endorse`)
      return { success: true }
    } catch (error) {
      /* empty */
    }
  },
}
